import { useState } from "react";
import { VStack, HStack, Text, Image } from "@chakra-ui/react";
import TeamsService from "../../services/TeamsService";
import { SecondaryLoginButton } from "./SecondaryLoginButton";
import MicrosoftIcon from "../../assets/icons/microsoft-icon.png";

const LoginForm = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleMicrosoftLogin = async () => {
    console.log("🔘 Microsoft login button clicked");
    setIsLoading(true);

    try {
      console.log("🔄 Initializing TeamsService");
      const teamsService = TeamsService.getInstance();
      await teamsService.initialize();
      console.log("✅ TeamsService initialized");

      console.log("🔐 Calling teamsService.authenticate()");
      const token = await teamsService.authenticate();
      console.log("✅ Authentication completed, token received:", !!token);

      if (token) {
        // Token is stored in sessionStorage by TeamsService
        // Navigate to workspace
        console.log("🚀 Navigating to /workspace");
        window.location.href = "/workspace";
      } else {
        console.error("❌ No token returned from authenticate()");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("❌ Microsoft login failed:", error);
      setIsLoading(false);
    }
  };

  return (
    <VStack gap={6} w="full">
      {/* Sign In with Microsoft Button */}
      <SecondaryLoginButton
        onClick={handleMicrosoftLogin}
        isLoading={isLoading}
      >
        <HStack gap={2}>
          <Image src={MicrosoftIcon} alt="Microsoft Icon" w="20px" h="20px" />
          <Text>Sign In with Microsoft</Text>
        </HStack>
      </SecondaryLoginButton>
    </VStack>
  );
};

export default LoginForm;
